export default {
	common: {
		close: "Schliessen",
	},
	checkout: {
		steps: {
			cart: "Warenkorb",
			addresses: "Adressen",
			delivery: "Lieferung",
			offer: "Angebot",
		},
		back: "Zurück",
		next: "Weiter",
		cartWarning: {
			line1: "Einige Artikel in diesem Warenkorb werden derzeit blexonisiert, wurden noch nicht mit der neusten Version blexonisiert, oder der Preis hat sich geändert und wurde noch nicht neu berechnet.",
			line2: "Bitte berechnen Sie die Artikel neu oder wenden Sie sich bei Fragen an unser Helpdesk.",
		},
		deliveryAddressTitle: "Lieferadresse",
		invoiceAddressTitle: "Rechnungsadresse",
		moreAddresses: "Weitere Adressen...",
		paymentType: {
			title: "Zahlungsart",
			text: "Wir senden Ihnen eine Rechnung {method} an {email}.",
			digitalMethod: "elektronisch",
			postalMethod: "per Post",
			changeAddressTooltip: "Navigiert zu den Adresseinstellungen.",
			changeAddress: "Adresse ändern",
		},
		orderNumberCard: {
			title: "Auftragsnummer",
			description: "Sie können für diesen Auftrag eine eigene Auftragsnummer vergeben.",
			description2: "Wir erwähnen diese Nummer auf dem Lieferschein und der Rechnung.",
			placeholder: "Ihre Auftragsnummer",
		},
		notificationsCard: {
			title: "Benachrichtigungen",
			description:
				"Wir senden die Auftragsbestätigung und die Benachrichtigung über die Fertigstellung Ihres Auftrags an Ihre E-Mail Adresse ({email}). Optional können diese Nachrichten an eine weitere E-Mail Adresse gesendet werden. In den {link} kann ein Standardwert für diese E-Mail definiert werden.",
			settingsLink: "Kundenkonto-Einstellungen",
			additionalEmailCheckbox: "Nachrichten an eine zusätzliche Adresse schicken",
			additionalEmailPlaceholder: "E-Mail Adresse",
		},
		addressPicker: {
			title: "Adresse für Bestellung auswählen",
		},
	},
	offer: {
		pleaseSelect: "Bitte auswählen",
		currentlyUnavailable: "Aktuell nicht verfügbar",
		fastDelivery: "Schnelle Lieferung",
		bestPrice: "Günstigster Preis",
		downloadPdfTooltip: "Angebot als PDF-Dokument herunterladen",
		table: {
			position: "Position",
			price: "Preis",
			deliveryDate: "Lieferdatum (ab Werk)",
			noDatesAvailable: "Keine Liefertermine verfügbar",
			positionsInCartPlural: "{count} Positionen im Warenkorb",
			positionsInCartSingular: "Position im Warenkorb",
			orderDiscount: "Auftragsrabatt",
			packagingAndDelivery: "Verpackung & Lieferung {type}",
			accordingToEffort: "nach Aufwand",
			invoiceByPost: "Rechnung per Post",
			net: "Netto",
			vat: "MwSt. ({ratio}%)",
			total: "Total (inkl. MwSt.)",
		},
		acceptNachAufwand:
			"Ich bin mir bewusst, dass zusätzliche Kosten für Verpackung & Lieferung entstehen",
		acceptAgb: "Ich bin mit den {agb} einverstanden",
		buyNowTooltip: "Angebot kostenpflichtig und verbindlich bestellen",
		buyNow: "Jetzt Kaufen",
		requestOrderTooltip:
			"Die Bestellung wird an die verantwortliche in Ihrer Organisation zur Freigabe weitergeleitet.",
		requestOrder: "Bestellung beantragen",
		errors: {
			timerExpired: "Der Angebotstimer ist abgelaufen",
			offerInvalid:
				"Das Angebot ist nicht mehr gültig, da ein Artikel im Warenkorb aktualisiert wurde. Bitte berechnen Sie das Angebot neu.",
			agbNotAccepted: "Die AGBs müssen akzeptiert werden",
			nachAufwandNotAccepted: "Die Lieferkosten nach Aufwand müssen akzeptiert werden",
			noDeliveryDate: "Es muss ein Lieferdatum ausgewählt werden",
			manufacturerNotAvailable:
				"Dieses Angebot steht am gewählten Ort zur Rampenabholung nicht zur Verfügung. Wählen Sie einen anderen Ort zur Abholung oder Lieferung aus.",
		},
		or: "oder",
		emailOrderTooltip:
			"Nutzen Sie diese Möglichkeit, wenn Sie lieber per E-Mail (z.B. aus einem ERP/SAP-System) bestellen möchten.",
		emailOrder: "Angebot speichern (E-Mail Bestellung)",
		emailOrderHint:
			"Das Angebot wird als PDF-Dokument heruntergeladen. Für eine Bestellung, senden Sie uns das PDF-Dokument per E-Mail. Zum Beispiel als Anhang einer ERP/SAP Bestellung.",
		discountDialog: {
			title: "Wann erhalte ich Auftragsrabatt?",
			intro: "Bei der Berechnung eines Angebots werden alle darin enthalten Positionen berücksichtigt und es wird ein Auftragsrabatt kalkuliert.",
			factorsIntro: "Folgende Faktoren führen zu einer {reduction}",
			priceReduction: "Preisreduktion:",
			factor1: "Mehrere Artikel aus dem gleichen Rohmaterial (gleicher Werkstoff und gleiche Blechdicke)",
			factor2: "Mehrere Artikel mit den gleichen Bearbeitungen (Gewinde, Senkungen und Durchzüge) in gleichem Rohmaterial",
			factor3: "Mehrere Artikel mit gleicher Pulverbeschichtung (gleiches Pulver)",
			factor4: "Mehrere Artikel mit gleicher Verzinkung",
		},
		nachAufwandDialog: {
			title: "Transport nach Aufwand",
			text1: "Wir berechnen die Kosten für Verpackung und Versand per Post- oder LKW wenn möglich automatisch.",
			text1b: "Auf Sperrgutversand per Post verzichten wir bewusst, da der Verpackungsaufwand bei dieser Versandart meistens unverhältnismässig hoch ist.",
			text1c: "Grosse und/oder schwere Teile werden per LKW geliefert. Hier ist eine automatische Berechnung im Voraus nicht immer möglich.",
			text2: "Der Preis ist abhängig vom Verpackungsaufwand, der Distanz zum Lieferort, dem Gewicht der Teile und von der Abmessung aller Teile der gesamten Lieferung.",
			text2b: "Bei grossen Teilen (grösser als eine Europalette) fällt die Abmessung preislich sehr ins Gewicht. Die Lieferung wird mit jedem zusätzlichen Zentimeter teurer. Gleichzeitig ist es sehr schwierig, automatisch zu berechnen, wie sich Biegeteile stapeln lassen und welche Verpackung notwendig ist, um einen sicheren Transport zu gewährleisten.",
			text3Bold:
				"Wir berechnen ihnen deshalb bei Lieferungen nach Aufwand den tatsächlichen Betrag, welcher unser Spediteur gemäss Tarif ASTAG verlangt. Zusätzlich berechnen wir den Zeitaufwand für das Verpacken auf die Minute genau.",
			text3: "Sie können davon ausgehen, dass eine Lieferung per LKW nach Aufwand in der Regel zwischen {currency} 100.- und 200.- zu liegen kommt.",
			text3b: "Bei sehr grossen Sendungen, z.B. mehrere Europaletten oder grossflächigen Sendungen (Länge x Breite > 200cm x 100cm), kann der Preis höher ausfallen. Kontaktieren Sie im Zweifelsfall unser Helpdesk auf {email}",
			text4: "Wir sind uns bewusst, dass es für unsere Kunden wichtig ist, den Endpreis, inklusive aller Kosten, vor der Bestellung zu kennen. Technische Limitationen machen das im Moment in gewissen Fällen unmöglich. Wir haben uns bewusst gegen eine Pauschale entschieden, weil wir überzeugt sind, mit dieser Regelung eine transparentere und kosteneffizientere Lösung, welche der Realität entspricht, zu bieten.",
		},
		orderFailedDialog: {
			title: "Bestellung fehlgeschlagen",
			text: "Während dem Bestellvorgang ist ein Fehler aufgetreten.",
			text2: "Kontaktieren Sie für Unterstützung unser Helpdesk auf {email}",
		},
	},
	offerInformation: {
		calculating: "Ihr Angebot wird berechnet...",
		calculatingHint: "Lieferkosten und Liefertermine werden mit den Fertigungspartnern bestimmt.",
		calculatingHint2: "Bei vielen Positionen kann das ein bis zwei Minuten dauern.",
		thanksForOrderTitle: "Vielen Dank für Ihre Bestellung.",
		orderedDirectlyText:
			"Sie können den Status des Auftrags von nun an in der Bestellübersicht einsehen. Ebenfalls werden sie in Kürze eine Bestätigungsemail erhalten.",
		thanksForOrderTitle2: "Vielen Dank für Ihren Auftrag.",
		orderedIndirectlyText:
			"Die verantwortlichen Personen in Ihrer Organisation werden in Kürze per E-Mail über Ihren Auftrag informiert. Diese Personen können die Bestellung, bei Bedarf, anpassen und anschliessend freigeben. Sobald Ihr Bedarf bestellt wurde, können Sie den Status des Auftrags in der Bestellübersicht einsehen. Ebenfalls erhalten Sie dann eine Bestätigungsemail.",
		backToArticlesTooltip: "Navigiert zum Artikelkatalog.",
		backToArticles: "Zu meinen Artikeln",
		offerSavedTitle: "Vielen Dank für Ihre Anfrage.",
		offerSavedText: "Ihr Angebots-PDF wurde erfolgreich heruntergeladen.",
		offerSavedText2:
			"Wenn Sie unser Angebot annehmen möchten, senden Sie uns das PDF bitte per E-Mail an {email}.",
		offerSavedText3:
			"Sollten Sie Ihre Bestellung über ein ERP- oder SAP-System übermitteln, bitten wir Sie ebenfalls, das PDF-Dokument beizufügen.",
		offerSavedText4: "Auf diese Weise können wir Ihre Anfrage schnell und effizient bearbeiten.",
		countryNotServiced: "Angebot nicht möglich",
		countryNotServicedText: "Leider beliefern wir zur Zeit noch keine Kunden in Ihrem Land.",
		countryNotServicedText2: "Sobald sich das ändert, werden wir Sie per Newsletter informieren.",
		noFertigerCanProduce:
			"Es können nicht alle Positionen des Warenkorbs an einem einzigen Standort produziert werden,",
		noFertigerCanProduce2: "da sich Rohmaterialien und/oder Bearbeitungen ausschliessen.",
		noFertigerCanProduce3:
			"In der Regel kann der Auftrag gefertigt werden, wenn die Positionen entsprechend aufgeteilt werden.",
		noFertigerCanProduce4:
			"Falls Sie dabei Unterstützung benötigen, klicken Sie auf den untenstehenden Button, um unser Helpdesk zu informieren.",
		noFertigerHasDeliveryDate:
			"Aufgrund hoher Auslastung oder einer sehr hohen Bestellmenge konnten keine Liefertermine für Ihren Auftrag gefunden werden.",
		noFertigerHasDeliveryDate2:
			"Klicken Sie auf den untenstehenden Button, wenn Sie ein Angebot für die angefragte Menge erhalten möchten.",
		genericFailed: "Angebot konnte nicht erstellt werden.",
		genericFailed2:
			"Leider ist bei der Erstellung Ihres Angebots ein Fehler aufgetreten. Versuchen Sie es erneut.",
		genericFailed3: "Falls der Fehler weiterhin auftritt. Informieren Sie uns mit dem untenstehenden Button.",
		notifyHelpdeskTooltip: "Blexon Helpdesk informieren",
		notifyHelpdesk: "Helpdesk benachrichtigen",
		offerValidPlural:
			"Ihre Angebote sind 15 Minuten lang gültig. Nach Ablauf der Gültigkeit können Sie eine Neuberechnung starten.",
		offerValidSingular:
			"Ihr Angebot ist 15 Minuten lang gültig. Nach Ablauf der Gültigkeit können Sie eine Neuberechnung starten.",
		recalculate: "Neu berechnen",
		helpdeskDialog: {
			title: "Blexon Helpdesk benachrichtigen",
			text: "Unser Helpdesk wird über die Situation informiert und meldet sich so schnell wie möglich bei der folgenden Adresse.",
			emailLabel: "E-Mail für Benachrichtigungen",
			cancelTooltip: "Aktion abbrechen",
			okButton: "Ok",
			okTooltip: "Helpdesk informieren",
		},
		messages: {
			helpdeskInformed: "Helpdesk wurde informiert.",
			helpdeskInformError: "Helpdesk konnte nicht informiert werden.",
		},
	},
	delivery: {
		title: "Lieferart",
		question: "Auf welchem Weg möchten Sie die Blechteile zugestellt bekommen?",
		producedBy: "Hergestellt von: {name}",
		deliveryOption: "Geliefert (1-2 Tage ab Lieferdatum)",
		rampeOption: "Rampenabholung (unverpackt)",
		fertigerLoadError: "Die Fertiger konnten nicht geladen werden.",
		selectionRequired: "Bitte wählen Sie einen Standort für die Rampenabholung.",
		addressDialog: {
			title: "Adresse für Rampenabholung",
			phoneLabel: "Tel.:",
		},
		notPossibleDialog: {
			title: "Rampenabholung nicht möglich",
			text: "Die Abholung dieser Bestellung ist bei diesem Fertigungspartner leider nicht möglich. Es kann sein, dass dieser Fertigungspartner keine Rampenabholung anbietet, oder dass ein Material oder eine Bearbeitung nicht verfügbar ist.",
		},
	},
	summary: {
		chooseOffer: "Wählen Sie Ihr Angebot",
		yourOffer: "Ihr Angebot",
	},
};
